import moment from "moment";
import $axios from "axios";
import { element_exists, redesignDataTablesHeader } from "../functions";
import { addSelectedCompanyHandler } from "../jquery-functions-library";
import {getSelectedCompany, getSelectedCompanyForUser } from "../jquery-functions-library";
import * as toastr from "toastr";
import { delay, template } from "lodash";

export var fnCustomerEmployeesTable = function() {
  var tableName = "#datatable-customer-employees";

  if (!element_exists(tableName) || $.fn.dataTable.isDataTable(tableName))
    return false;

  const companyChanged = () => {
    table.ajax.reload();
  };

  addSelectedCompanyHandler(companyChanged);

  var columns = [
    { data: "company_id" },
    { data: "select" },
    { data: "full_name" },
    { data: "employment_date" },
    { data: "termination_date" },
    { data: "changes" },
    { data: "actions" },
  ];

  /*Rules for filling the columns*/
  var columnDefs = [
    { visible: false, targets: 0 },
    {
      orderable: false,
      className: "select-checkbox-gyro dt-center",
      checkboxes: {
        selectRow: true,
      },
      targets: 1,
    },
    { width: "5%", targets: 2 },
    { width: "5%", targets: 3 },
    { width: "5%", targets: 4 },
    { width: "5%", targets: 5 },
    { width: "13%", targets: 6 },
  ];

  /*Important otherwise table misaligned*/
  $(tableName).css("width", "100%");

  var table = $(tableName).DataTable({
    language: allLangFiles.datatables,
    rowId: "id",
    ajax: {
      url: "/employees/get",
      dataSrc: function(json) {
        console.log(json);
        return json.data;
      },
    },
    select: {
      style: "multi",
      selector: "td:first-child",
      info: false,
    },
    columns: columns,
    columnDefs: columnDefs,
    scrollX: true,
    lengthMenu: [[-1, 10, 25, 50, 75, 100], [allLangFiles.datatables.all, 10, 25, 50, 75, 100]],
    order: [
      [6, "desc"],
      [2, "asc"] 
    ],
    initComplete: function(settings, json) {
      console.log(json.data);

      table.draw();
    },
  });

  //add popover to tooltip in changes column
  $(tableName).on("draw.dt", function() {
    $('[data-toggle="popover"]').popover(
      {
        delay: 0,
        template: popOverTemplate
      }
    );
  });


  const popOverTemplate = `
    <div class="popover" role="tooltip">
      <div class="popover-arrow"></div>
      <h3 class="popover-title only-title"></h3>
      <div class="popover-content hidden"></div>
    </div>
  `;
  
  const { $filterButtons } = redesignDataTablesHeader(tableName, true);
  $filterButtons.prepend($("#btn-admin-upload-employees"));
  $filterButtons.prepend($("#btn-upload-employees"));
  $filterButtons.prepend($("#btn-create-employee"));
  $filterButtons.append($("#btn-export-employee-changes"));
};

$(document).off('click', '#btn-export-employee-changes');
$(document).on("click", "#btn-export-employee-changes", function() {
  showExportModal();
});

function showExportModal() {
  var modalConent = `
    <form class="form-inline export-interval-form">
        <div class="form-group bmd-form-group">
            <input id="export-from" class='pull-right form-control color-white'/>
        </div>
        <div class="form-group bmd-form-group">
            <input id="export-to" class='pull-right form-control color-white'/>
        </div>
    </form>
    `;

  $.confirm({
    onOpen: function() {
      this.$content.find("#export-from").datepicker({
        format: "dd/mm/yyyy",
      }).datepicker('setDate', moment().startOf("month").format("DD/MM/YYYY"));

      this.$content.find("#export-to").datepicker({
        format: "dd/mm/yyyy",
      }).datepicker('setDate', moment().endOf("month").format("DD/MM/YYYY"));
    },
    title: allLangFiles.forms.export_all_changes_title,
    content: modalConent,
    theme: "supervan",
    columnClass: "col-md-12",
    backgroundDismiss: true,
    buttons: {
      Export: {
        text: "Export",
        action: function() {
          var from = moment(this.$content.find("#export-from").val(), "DD/MM/YYYY").format("YYYY-MM-DD");
          var to = moment(this.$content.find("#export-to").val(), "DD/MM/YYYY").format("YYYY-MM-DD");
          //check first if user has selected company if not get selected company for user
          var company_id = getSelectedCompany() ? getSelectedCompany() : getSelectedCompanyForUser();          
          $axios.get('salary/employees/changes/' + company_id + '/export?from=' + from + '&to=' + to).then(function(response) {

            if (response.data.no_changes !== undefined) {
              toastr.success(response.data.no_changes);
            } 

            if (response.data.no_changes == undefined) {
              window.location.href = response.request.responseURL;
            } 
          }); 
        },
      },
      Cancel: {
        text: "Cancel",
      },
    },
  });
}